export default "__VITE_ASSET__49478416__"